import { Box, Drawer, Stack } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { ReactNode } from 'react'
import { HousekeepingPlanAccumulatorViewStore } from '../../stores/housekeeping-plan-accumulator.view-store'
import { YardViewStore } from '../../stores/yard.view-store'
import { YardBlockContainerDetailsHeader } from '../atoms/YardBlockContainerDetailsHeader'
import { YardBlockContainerDetailsFooter } from '../atoms/YardBlockContainersDetailsFooter'
import { BlockContainerDetailsList } from '../molecules/BlockContainerDetailsList'
import { YardBlockContainerDetailsGrid } from '../molecules/YardBlockContainerDetailsGrid'

interface Props {
  viewStore: YardViewStore
  housekeepingPlanAccumulatorViewStore: HousekeepingPlanAccumulatorViewStore
  renderContainerDetailsByJourneyId: (
    journeyId: number,
    highlight?: boolean,
    isReserved?: boolean,
    schemeBackgroundColor?: string,
  ) => ReactNode
  drawerWidth: number
}
export const YardBlockContainers = observer(
  ({
    viewStore,
    housekeepingPlanAccumulatorViewStore,
    renderContainerDetailsByJourneyId,
    drawerWidth,
  }: Props) => {
    const theme = useMinimalsTheme()

    return (
      <Drawer
        open={viewStore.isContainerDetailsOpen && viewStore.isViewMode}
        anchor='right'
        variant={
          viewStore.isContainerDetailsOpen && viewStore.isViewMode ? 'permanent' : 'temporary'
        }
        onClose={() => viewStore.setContainerDetailsOpen(false)}
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
          },
        }}
      >
        <YardBlockContainerDetailsHeader
          selectedBay={viewStore.selectedBay}
          selectedRow={viewStore.selectedRow}
          yardBlock={viewStore.focusedYardBlock}
          onClose={() => viewStore.setContainerDetailsOpen(false)}
          onBayChange={bay => viewStore.setContainerDetailsOpen(true, bay, viewStore.selectedRow)}
          onRowChange={row => viewStore.setContainerDetailsOpen(true, viewStore.selectedBay, row)}
        />

        <Box sx={{ height: '90vh', overflow: 'auto' }}>
          <Stack
            padding={theme.customSpacing.m}
            spacing={theme.customSpacing.m}
            sx={{ width: 'fit-content', minWidth: '100%' }}
          >
            {viewStore.isFocusedBlockStandard && (
              <>
                <YardBlockContainerDetailsGrid
                  viewStore={viewStore}
                  housekeepingPlanAccumulatorViewStore={housekeepingPlanAccumulatorViewStore}
                  renderContainerDetailsByJourneyId={renderContainerDetailsByJourneyId}
                />

                <YardBlockContainerDetailsFooter
                  viewStore={viewStore}
                  selectedBay={viewStore.selectedBay}
                  columns={viewStore.containerDetailsColumns}
                />
              </>
            )}

            {!viewStore.isFocusedBlockStandard && (
              <BlockContainerDetailsList
                viewStore={viewStore}
                housekeepingPlanAccumulatorViewStore={housekeepingPlanAccumulatorViewStore}
                renderContainerDetailsByJourneyId={renderContainerDetailsByJourneyId}
              />
            )}
          </Stack>
        </Box>
      </Drawer>
    )
  },
)
